import React, { Component } from 'react';

process.env.__CLIENT__ && require('./AfterSale.less');
export default class AfterSale extends Component {
  render() {
    return (
      <div className="aftersale">
          <div className="aftersale-left">
              <p className="text1">新"促销中心"</p>
              <h1 className="text2">2020重磅上线</h1>
              <div className="textContent">
                <p className="text3">促销方案更灵活</p>
                <p className="textPoint"></p>
                <p className="text3">促销互斥更精准</p>
                <p className="textPoint"></p>
                <p className="text3">发布追溯更易用</p>
              </div>
              <a className="aftersalemore" href="https://mp.weixin.qq.com/s/PKtlxgyMXMiFMvODgvsH-Q" target="_blank">点击了解</a>
          </div>
          <div className="aftersale-right"></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/components/home/AfterSale.jsx